import WaldogramReferralPlaceholder from './WaldogramReferralPlaceholder';

export default WaldogramReferralPlaceholder;
